module.exports = __webpack_public_path__ + "img/knn3.4b9d58e4.png";